import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import * as runReducer from "containers/Run/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as projectReducer from "containers/Project/reducer";

import { GRAPH_TYPES } from "containers/Run/reducer";

import RunPlot from "components/RunPlot/nRunPlot";

class RunPlotContainer extends React.Component {
  shouldComponentUpdate(nextProps) {
    const { runPlotType, runPlotCapacity, modelPlotData, isQuickRun, selectedMiniBlueprint, ignoredModels } =
      this.props;

    if (
      runPlotType !== nextProps.runPlotType ||
      runPlotCapacity !== nextProps.runPlotCapacity ||
      (modelPlotData === undefined && nextProps.modelPlotData) ||
      isQuickRun !== nextProps.isQuickRun ||
      selectedMiniBlueprint !== nextProps.selectedMiniBlueprint ||
      ignoredModels !== nextProps.ignoredModels
    ) {
      return true;
    }

    if (modelPlotData && nextProps.modelPlotData) {
      if (
        modelPlotData[0] &&
        nextProps.modelPlotData[0] &&
        modelPlotData[0].x &&
        nextProps.modelPlotData[0].x &&
        modelPlotData[0].x !== nextProps.modelPlotData[0].x
      ) {
        return true;
      }
    }

    return true;
  }

  render() {
    const { modelPlotData } = this.props;

    return (
      <RunPlot
        {...this.props}
        data={modelPlotData}
        padding={10}
        style={{ height: "calc(100vh - 167px)", background: "white" }}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateFeatureSelection: (modelId) => dispatch(runReducer.updateFeatureSelection(ownProps.id, modelId)),
    updateRunPlotType: (type) => {
      if (ownProps.updatePlotType) {
        return ownProps.updatePlotType(type);
      } else {
        return dispatch(projectReducer.updateRunPlotType(ownProps.projectId, type));
      }
    },
    updateRunPlotCapacity: (val) => dispatch(runReducer.updateRunPlotCapacity(ownProps.id, val))
  };
};

const mapStateToProps = (state, ownProps) => {
  const projectId =
    ownProps.projectId !== undefined ? ownProps.projectId : projectReducer.getProjectIdFromRunId(state, ownProps.id);

  const currSegment = projectReducer.getSegments(state, projectId)?.find((seg) => seg?.runId === ownProps.id);
  const cBestModel = currSegment?.model;
  const models = runReducer.getTransformedSortedModels(state, ownProps.id);
  const bestModel = cBestModel && cBestModel?.id ? cBestModel : models && models.length > 0 ? models[0] : undefined;

  const featureModel = runReducer.getFeatureSelection(state, ownProps.id, true);
  const chooseModel =
    models.filter((m) => m.id === featureModel).length > 0 ? models.filter((m) => m.id === featureModel)[0] : undefined;

  let runPlotType = ownProps.plotType || projectReducer.getRunPlotType(state, ownProps.projectId);
  if (ownProps.hideLineGraphs && runPlotType === GRAPH_TYPES.COST_COMPARISON) {
    runPlotType = GRAPH_TYPES.ACCURACY;
  }

  return {
    modelPlotData: runReducer.getModelPlotData(state, ownProps.id, runPlotType, ownProps.fids),
    runPlotCapacity: runReducer.getRunPlotCapacity(state, ownProps.id),
    processLimitPct: setupReducer.getProcessLimitPct(state, ownProps.id),
    models: models,
    isTwoMinuteRun: setupReducer.getIsTwoMinuteRun(state, ownProps.id),
    isQuickRun: setupReducer.getIsQuickRun(state, ownProps.id),
    isContinuous: runReducer.getIsContinuous(state, ownProps.id),
    runPlotType: runPlotType,
    currentModel: chooseModel ? chooseModel : bestModel
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RunPlotContainer);
